import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';

enum Tabs {
  record = 'Historial',
  comments = 'Comentarios',
  files = 'Archivos',
}
@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.scss'],
})
export class HistorialComponent implements OnInit, OnChanges {
  public Tabs = Tabs;
  @Input() historial: any[];
  @Input() view: boolean = false;
  @Output() hidden = new EventEmitter<boolean>();

  selected: Tabs = Tabs.record;

  constructor() {}

  ngOnChanges() {
    if (this.view) {
      console.log('buscar data');
    }
  }

  ngOnInit(): void {}

  clickHidden() {
    this.hidden.emit(false);
  }
}
